module.exports = __webpack_public_path__ + "img/figure1.5f5f94e5.png";